export class LFDynamicWidgetConfig {
    public name: string;
    public id: string;
    public widgetType: string;
    public isOpen: boolean = false;
    public activeIndex: number;
    public columnGroup: string;
    public propertyList: any;
}
